import { FormFooterWizard } from 'components/FormFooterWizard'
import { WIZARD_NAVIGATION } from 'components/FormFooterWizard/FormFooterWizard'
import { CurrentFormikContext } from 'context'
import { Formik, FormikConfig } from 'formik'
import { invokeAll } from 'helpers'
import { IPanelProps, Panel, PanelType } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { WizardState } from 'views/ProvingDetailsView/PageParticipants'

export type FormikPanelWizardProps<TValues = any> = Omit<
  IPanelProps,
  'onRenderFooter' | 'onRenderFooterContent' | 'isFooterAtBottom' | 'onSubmit'
> &
  Pick<
    FormikConfig<TValues>,
    'initialValues' | 'validationSchema' | 'onSubmit' | 'onReset'
  > & {
    submitText?: string
    enableSubmit?: boolean
    handleWizardChange: (action: WIZARD_NAVIGATION) => void
    wizardState: { state: WizardState; active: boolean }[]
    onNextClick?: () => void
  }

export const FormikPanelWizard: React.FunctionComponent<
  FormikPanelWizardProps<any>
> = ({
  initialValues,
  validationSchema,
  onSubmit,
  onReset,
  onDismiss,
  children,
  submitText,
  enableSubmit,
  handleWizardChange,
  wizardState,
  onNextClick,
  ...panelProps
}) => {
  const { t } = useTranslation()

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      onReset={onReset}
      render={(formikProps) => (
        <Panel
          type={PanelType.medium}
          closeButtonAriaLabel={t('action.close')}
          onDismiss={onDismiss}
          {...panelProps}
          onDismissed={() => formikProps.resetForm(initialValues || {})}
          onRenderFooterContent={() => (
            <FormFooterWizard
              onCancelClick={invokeAll<any>(
                formikProps.resetForm.bind(formikProps, undefined),
                onDismiss
              )}
              onNextClick={onNextClick}
              wizardState={wizardState}
              previousText="Zurück"
              nextText="Überspringen"
              cancelText="Beenden"
              handleWizardChange={handleWizardChange}
              onSubmitClick={formikProps.submitForm}
              submitDisabled={
                formikProps.isSubmitting ||
                !formikProps.isValid ||
                !formikProps.dirty
              }
            />
          )}
          isFooterAtBottom={true}
        >
          <CurrentFormikContext.Provider value={formikProps}>
            {panelProps.isOpen ? children : null}
          </CurrentFormikContext.Provider>
        </Panel>
      )}
    />
  )
}
